import React from "react";
import styled from "styled-components";
import { breakpoints } from "@trailhead/asurion-ui";
import { FlexColumnContainer } from "@trailhead/core-ui";
import { useSanitizedTranslation } from "@trailhead/i18n";

import newPhone from "../assets/new-phone.svg";

const IntroHeaderContainer = styled(FlexColumnContainer)`
  justify-content: space-evenly;
  align-items: center;
  align-self: center;
  width: 100%;
  color: #000000;
  ${breakpoints.md} {
    align-items: flex-start;
    align-self: flex-start;
    flex: 0 0 50%;
    border-bottom: none;
  }
`;

const NewPhoneImage = styled.img`
  position: relative;
  display: block;
`;

export const IntroHeader: React.FC = () => {
  const t = useSanitizedTranslation();
  return (
    <IntroHeaderContainer>
      <NewPhoneImage
        src={newPhone}
        alt={t("Person holding their new device")}
      />
    </IntroHeaderContainer>
  );
};
